import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, of, Subscription } from 'rxjs';
import { map, catchError, switchMap, finalize, tap } from 'rxjs/operators';
import { UserLoginData, UserModel } from '../models/user.model';
import { AuthModel } from '../models/auth.model';
//import { AuthHTTPService } from './auth-http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import * as CryptoJS from 'crypto-js';
import { SharedService } from 'src/app/services/shared.service';

export type UserType = UserModel | undefined;

@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  // private fields
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  //private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  //baseURL: string = environment.HTTP;
  // public fields
  currentUser$: Observable<UserType>;
  isLoading$: Observable<boolean>;
  currentUserSubject: BehaviorSubject<UserType>;
  isLoadingSubject: BehaviorSubject<boolean>;
  baseURL: string = environment.HTTP;
  secretKey = "qubeappsPro_token";

  get currentUserValue(): UserType {
    return this.currentUserSubject.value;
  }

  set currentUserValue(user: UserType) {
    this.currentUserSubject.next(user);
  }

  constructor(
    private http: HttpClient,
    private apiService:ApiService,
    private shareService:SharedService,
    //private authHttpService: AuthHTTPService,
    private router: Router
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.currentUserSubject = new BehaviorSubject<UserType>(undefined);
    this.currentUser$ = this.currentUserSubject.asObservable();
    this.isLoading$ = this.isLoadingSubject.asObservable();

    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        const decryptedAccessToken = CryptoJS.AES.decrypt(token, this.secretKey).toString(CryptoJS.enc.Utf8);
        const accessToken = JSON.parse(decryptedAccessToken);
        this.currentUserSubject.next(accessToken);
      } catch (error) {
        localStorage.removeItem("access_token");
        this.currentUserSubject.next(undefined);
      }
    }
      
    //const subscr = this.getUserByToken().subscribe();
    //this.unsubscribe.push(subscr);
  }

  getUser(): Observable<UserType> {
    return this.apiService.getCurrentUser().pipe(
      map((user: UserType) => {
        if (user) {
          const userProfile = user.data;
          const EncryptUser = CryptoJS.AES.encrypt(JSON.stringify(userProfile), this.secretKey).toString();
          localStorage.setItem('up',EncryptUser)
    
          this.currentUserSubject.next(user);
        } else {
          this.logout();
        }
        return user;
      }),
    );
  }

  // public methods
  login(email: string, password: string): Observable<UserType> {
    this.isLoadingSubject.next(true);
    return this.apiService.login(email, password).pipe(
      tap((response: any) => {
        if (!response.success) {
          throw new Error('Login failed');
        } else {
          const accessToken = response.data.token;
          const savePermission = response.data.permissions;
          const Encryptdata = CryptoJS.AES.encrypt(JSON.stringify(savePermission), this.secretKey).toString();
          localStorage.setItem("pr", Encryptdata);
          const encryptedAccessToken = CryptoJS.AES.encrypt(JSON.stringify(accessToken), this.secretKey).toString();
          localStorage.setItem('access_token', encryptedAccessToken);
  
          // Here, you can set the email and password to currentUserSubject
          const user: UserModel = new UserModel();
          user.email = email;
          user.password = password;
          this.currentUserSubject.next(user);
        }
      }),
  
      catchError((err) => {
        console.error('Error:', err);
        throw err; // Re-throw the error to propagate it to the subscribe method
      }),
      finalize(() => this.isLoadingSubject.next(false)),
      map((response: any) => response.data),
    );
  }

  async APILogout()
  {
    return this.apiService.logout();
  }

  revokeall()
  {
    localStorage.clear();
  
      // Update the user subject
      this.currentUserSubject.next(undefined);
  
      // Navigate to the login page
      this.router.navigate(['/auth/login'], {
        queryParams: {},
      });
  
      console.log("Logout process completed");
  }

  async logout() {
    try {
      // Call the logout API and wait for its completion
      await (await this.APILogout()).toPromise();
      console.log("Logout API call successful");
    } catch (error) {
      // Handle API call failure
      console.error("Logout API call failed:", error);
      // You can choose to perform additional error handling here if needed.
    }
  
    // Even if the API call fails, continue executing the following steps.
    try {
      // Clear localStorage
      localStorage.clear();
  
      // Update the user subject
      this.currentUserSubject.next(undefined);
  
      // Navigate to the login page
      this.router.navigate(['/auth/login'], {
        queryParams: {},
      });
  
      console.log("Logout process completed");
    } catch (error) {
      console.error("Logout process failed:", error);
      // You can choose to perform additional error handling here if needed.
    }
  }
  

  // need create new user then login
  // registration(user: UserModel): Observable<any> {
  //   this.isLoadingSubject.next(true);
  //   return this.authHttpService.createUser(user).pipe(
  //     map(() => {
  //       this.isLoadingSubject.next(false);
  //     }),
  //     switchMap(() => this.login(user.email, user.password)),
  //     catchError((err) => {
  //       console.error('err', err);
  //       return of(undefined);
  //     }),
  //     finalize(() => this.isLoadingSubject.next(false))
  //   );
  // }

  // forgotPassword(email: string): Observable<boolean> {
  //   this.isLoadingSubject.next(true);
  //   return this.authHttpService
  //     .forgotPassword(email)
  //     .pipe(finalize(() => this.isLoadingSubject.next(false)));
  // }

  // private methods
  // private setAuthFromLocalStorage(auth: AuthModel): boolean {
  //   // store auth authToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
  //   if (auth && auth.authToken) {
  //     localStorage.setItem(this.authLocalStorageToken, JSON.stringify(auth));
  //     return true;
  //   }
  //   return false;
  // }

  // private getAuthFromLocalStorage(): AuthModel | undefined {
  //   try {
  //     const lsValue = localStorage.getItem(this.authLocalStorageToken);
  //     if (!lsValue) {
  //       return undefined;
  //     }

  //     const authData = JSON.parse(lsValue);
  //     return authData;
  //   } catch (error) {
  //     console.error(error);
  //     return undefined;
  //   }
  // }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
